module.exports = __webpack_public_path__ + "static/media/claims-icon.71597b81.svg";